<template>
  <div class="installation-card-step">
    <div class="image-with-step">
      <div class="step">
        <UiComponentHeading
          as="paragraph"
          :level="5"
        >
          <slot name="step" />
        </UiComponentHeading>
      </div>
      <UiComponentImage
        :alt="image.alt"
        :height="image.height"
        :expected-size="imageWidth"
        :source="image.url"
        :width="image.width"
      />
    </div>
    <UiComponentParagraph class="legend">
      <slot name="paragraph" />
    </UiComponentParagraph>
  </div>
</template>

<script setup>
// Composable
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  image: {
    default() {
      return {}
    },
    type: Object,
  },
})

// Computed
const imageWidth = computed(() => {
  switch (true) {
    case screenWidth.value < 768:
      return screenWidth.value - 32
    case screenWidth.value >= 768 && screenWidth.value < 1328:
      return 530
    default:
      return 400
  }
})
</script>

<style lang="postcss" scoped>
.installation-card-step {
  @apply flex flex-col;

  .image-with-step {
    @apply relative;

    .step {
      @apply absolute flex items-center justify-center z-10 w-10 h-10 rounded bg-white;
      top: 16px;
      left: 16px;

      .h5 {
        @apply text-grey-blue-900 font-medium;
      }
    }

    picture {
      border: 2px solid #fdede7;
      border-radius: 24px;
    }
  }

  .legend {
    @apply mt-6 text-grey-blue-600 text-center;

    @screen xl {
      @apply text-left;
    }
  }
}
</style>
